/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import styles from './styles.scss';

const defaultProps = {
  checked: false,
  onChange: () => {},
  disabled: false,
  children: null,
};

const propTypes = {
  id: React.PropTypes.string.isRequired,
  checked: React.PropTypes.bool,
  onChange: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  children: React.PropTypes.node,
};

class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.checked,
      disabled: props.disabled,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { checked, disabled } = nextProps;
    if (checked !== this.props.checked) {
      this.setState({ checked, disabled });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled });
    }
  }

  render() {
    const { id, onChange } = this.props;
    const { checked, disabled = false } = this.state;
    return (
      <div className={`${styles.checkbox} ${disabled ? styles.disabled : ''}`}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          disabled={disabled}
        />
        <label htmlFor={id} />
      </div>
    );
  }
}

Checkbox.defaultProps = defaultProps;
Checkbox.propTypes = propTypes;

export default Checkbox;




// WEBPACK FOOTER //
// ./src/components/Checkbox/index.jsx